import type { ClassFormSchemaValues } from "../schemas/classForm.schema";
import { resolveLevel3Label } from "./level3LabelCache";

export function computeTotalPrice(price: number, taxPercent: number): number {
  return Math.round(price + (price * taxPercent) / 100);
}

export function slugifyClassName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 80) || `class-${Date.now()}`;
}

export function formValuesToPayload(values: ClassFormSchemaValues) {
  const price = Number(values.price);
  const taxPercent = Number(values.taxPercent);
  return {
    name: values.name.trim(),
    description: values.description.trim(),
    validityDays: Number(values.validityDays),
    price,
    taxPercent,
    totalPrice: computeTotalPrice(price, taxPercent),
    level1Id: values.level1Id,
    level2Id: values.level2Id,
    level3Id: values.level3Id,
    level3Label: resolveLevel3Label(values.level3Id),
    benefits: values.benefits.map((b) => ({
      id: b.id,
      title: b.title.trim(),
      description: b.description.trim(),
    })),
    school: {
      schoolName: (values.schoolName ?? "").trim(),
      adminName: (values.adminName ?? "").trim(),
      email: (values.email ?? "").trim(),
      contactNumber: (values.contactNumber ?? "").trim(),
      linkedGradeIds: values.courseId ? [values.courseId] : [],
      schoolTitle: values.schoolTitle,
      licenseCountTeacher: values.licenseCountTeacher,
      licenseCountStudent: values.licenseCountStudent,
      location: values.location,
    },
    thumbnailUrl: values.thumbnailUrl,
    uploadId: values.uploadId,
    schoolId: values.schoolId,
    courseId: values.courseId ?? "",
  };
}
